module.exports = __webpack_public_path__ + "static/media/product4.94dea243.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/product4.png
// module id = 529
// module chunks = 0